module.exports = __webpack_public_path__ + "img/cart-flatbed-empty.09d8858e.svg";